import { render, staticRenderFns } from "./AddStorageLocation.vue?vue&type=template&id=3478815c&"
import script from "./AddStorageLocation.vue?vue&type=script&lang=js&"
export * from "./AddStorageLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports